import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { store } from './store/store';
import { IS_TENANT_MODE } from './config/tenantMode';
import { TENANT_DEFAULT_ACCENT, TENANT_DEFAULT_PRIMARY } from './hooks/useDisplayBranding';
import './i18n/config'; // Initialize i18n
import './styles/index.css';

if (IS_TENANT_MODE) {
  document.documentElement.setAttribute('data-platform', 'tenant');
  document.documentElement.style.setProperty('--brand-primary', TENANT_DEFAULT_PRIMARY);
  document.documentElement.style.setProperty('--brand-accent', TENANT_DEFAULT_ACCENT);
  document.documentElement.style.setProperty('--brand-cyan', TENANT_DEFAULT_ACCENT);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);

